<template>
  <div class="fip-content">
    <fip-detail :item="item" />
  </div>
</template>

<script>
import FipDetail from './fipDetail/FipDetail'

export default {
  name: 'FipContent',
  components: { FipDetail },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .fip-content {
    max-width: 1280px;
    margin: auto;
    @include mediaQueries('padding', (xsmall: 15px 15px, medium: 20px 27px, large: 24px 55px));
  }
</style>
